import React from '../node_modules/react';
import ReactDOM from '../node_modules/react-dom';
import App from './app';

ReactDOM.render(<App />, document.getElementById('stationRoot'));




// WEBPACK FOOTER //
// ./stations/index.js